<template>
  <div class="page" v-loadingx="loading">
    <Title :title="title || (yearNum + '年采购明细')">
      <div class="b-detail-t-s">
        <fm-date-picker style="width: 7rem;" @change="yearChange" v-model="year" type="year" placeholder="请选择年份"></fm-date-picker>
      </div>
    </Title>
    <div class="count">
      <div class="c-item" :class="{'c-item-nb': index === countData.length - 1}" v-for="(item, index) in countData" :key="index">
        <div class="t">{{item.title}}</div>
        <div class="num">
          <Money :money="item.value"></Money>
          <div class="img-d">
            <img :src="item.src" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="detail">
      <div class="search">
        <div class="search-item">
          <div class="label">是否关联预算</div>
          <div class="form">
            <fm-select :clearable="true" v-model="search.isPlanText">
              <fm-option v-for="item in ['关联', '未关联']" :key="item" :value="item" :label="item"></fm-option>
            </fm-select>
          </div>
        </div>
        <div class="search-item">
          <div class="label">申请部门</div>
          <div class="form">
            <fm-select :clearable="true" v-model="search.orgId">
              <fm-option v-for="item in orgList" :key="item.key" :value="item.key" :label="item.label"></fm-option>
            </fm-select>
          </div>
        </div>
        <div class="search-item">
          <div class="label">申请部门分管领导</div>
          <div class="form">
            <fm-select :clearable="true" v-model="search.leadUserId">
              <fm-option v-for="item in leadUserList" :key="item.key" :value="item.key" :label="item.label"></fm-option>
            </fm-select>
          </div>
        </div>
        <div class="search-item">
          <div class="label">对口职能科室</div>
          <div class="form">
            <fm-select :clearable="true" v-model="search.busOrgId">
              <fm-option v-for="item in busOrgList" :key="item.key" :value="item.key" :label="item.label"></fm-option>
            </fm-select>
          </div>
        </div>
        <div class="search-item">
          <div class="label">采购部门分管领导</div>
          <div class="form">
            <fm-select :clearable="true" v-model="search.purchaseLeadUserId">
              <fm-option v-for="item in purchaseLeadUserList" :key="item.key" :value="item.key" :label="item.label"></fm-option>
            </fm-select>
          </div>
        </div>
        <div class="search-item">
          <div class="label">状态</div>
          <div class="form">
            <fm-select clearable v-model="search.status">
              <fm-option v-for="item in statusList" :key="item.key" :value="item.key" :label="item.label"></fm-option>
            </fm-select>
          </div>
        </div>
        <div class="search-item">
          <fm-btn @click="output">批量导出</fm-btn>
        </div>
      </div>
      <div class="table">
        <fm-table-new
          :simple-filter="false"
          :columns="columns"
          :auto-height="true"
          border="row"
          :export-file-name="title || (yearNum + '年采购明细')"
          ref="table"
          :data-list="showDetail"
          :stripe="true"
          emptyPlaceholder="-">
        </fm-table-new>
      </div>
    </div>
  </div>
</template>

<script>
import { purchaseBatchDetailsRequest } from '../../api'

import Title from './components/cmp/title'
import Money from './components/cmp/money'
import { purchaseExport } from './lib'

export default {
  components: {
    Title,
    Money
  },
  activated () {
    if (this.$route.query.id || this.$route.query.year) {
      if (this.$route.query.id) {
        this.id = this.$route.query.id
        this.year = null
        this.title = this.$route.query.title
      }
      if (this.$route.query.year) {
        this.year = new Date(this.$route.query.year + '-02-01')
      }
    } else {
      this.year = new Date()
      this.id = null
      this.title = null
    }
    this.loadData()
  },
  data () {
    return {
      title: null,
      year: new Date(),
      id: null,
      orgList: [],
      leadUserList: [],
      busOrgList: [],
      purchaseLeadUserList: [],
      search: {
        isPlanText: null,
        orgId: null,
        leadUserId: null,
        busOrgId: null,
        purchaseLeadUserId: null,
        status: null
      },
      detail: [],
      loading: false,
      statusList: []
    }
  },
  computed: {
    yearNum () {
      return this.year ? this.year.getFullYear() : null
    },
    columns () {
      return [{
        field: 'isPlanText',
        title: '是否关联预算'
      },
      {
        field: 'goodsName',
        width: 200,
        title: '名称'
      },
      {
        field: 'typeDetail',
        title: '可选品牌及规格型号'
      },
      {
        field: 'num',
        title: '采购申请数量'
      },
      {
        field: 'price',
        title: '采购申请单价'
      },
      {
        field: 'total',
        title: '采购申请总价'
      },
      {
        field: 'orgName',
        title: '申请部门'
      },
      {
        field: 'leadUserName',
        title: '申请部门分管领导'
      },
      {
        field: 'busOrgName',
        title: '职能科室'
      },
      {
        field: 'purchaseLeadUserName',
        title: '采购分管领导'
      },
      {
        field: 'statusText',
        width: 200,
        title: '状态',
        fixed: 'right'
      },
      {
        field: 'action',
        title: '操作',
        fixed: 'right',
        render: (h, row) => {
          return h('fm-btn', {
            on: {
              click: () => this.print(row)
            }
          }, '打印')
        }
      }]
    },
    showDetail () {
      let allData = this.detail
      Object.keys(this.search).forEach(key => {
        if (this.search[key]) {
          allData = allData.filter(v => v[key] === this.search[key])
        }
      })
      return allData
    },
    countData () {
      let count = {
        total: 0,
        planTotal: 0
      }
      this.showDetail.forEach(v => {
        count.total += v.total
        if (v.isPlan) {
          count.planTotal += v.total
        }
      })
      let data = [{
        title: '总采购申请金额',
        value: count.total,
        src: '/static/images/budget/l1.png'
      },
      {
        title: '已关联预算金额',
        value: count.planTotal,
        src: '/static/images/budget/l22.png'
      },
      {
        title: '未关联预算金额',
        value: count.total - count.planTotal,
        src: '/static/images/budget/l3.png'
      }]
      return data
    }
  },
  methods: {
    async print (row) {
      this.loading = true
      const param = { statusActionRecord: 1, id: row.id }
      let data = null
      if (this.$authFunsProxy.get) {
        data = await purchaseBatchDetailsRequest.get(param)
      } else if (this.$authFunsProxy.getByAuth) {
        data = await purchaseBatchDetailsRequest.getByAuth(param)
      }
      if (!data || !data.length) {
        this.loading = false
        return this.$notice.error('数据不存在')
      }
      await purchaseExport(data[0])
      this.loading = false
    },
    output () {
      this.$refs.table.openExport()
    },
    yearChange () {
      if (this.year) {
        this.search.status = null
        this.id = null
        this.title = null
        this.loadData()
      }
    },
    async loadData () {
      this.detail = []
      let parm = {}
      if (this.yearNum) {
        parm.year = this.yearNum
      }
      if (this.id) {
        parm.budgetYearId = this.id
      }
      this.loading = true
      this.detail = []
      if (this.$authFunsProxy.get) {
        this.detail = await purchaseBatchDetailsRequest.getInfo(parm)
      } else if (this.$authFunsProxy.getByAuth) {
        this.detail = await purchaseBatchDetailsRequest.getInfoByAuth(parm)
      }

      this.orgList = []
      this.leadUserList = []
      this.busOrgList = []
      this.purchaseLeadUserList = []
      let statusList = {}
      this.detail.forEach(v => {
        statusList[v.status] = v.statusText
        if (v.orgId && !this.orgList.find(v1 => v1.key === v.orgId)) {
          this.orgList.push({
            key: v.orgId,
            label: v.orgName
          })
        }
        if (v.leadUserId && !this.leadUserList.find(v1 => v1.key === v.leadUserId)) {
          this.leadUserList.push({
            key: v.leadUserId,
            label: v.leadUserName
          })
        }
        if (v.busOrgId && !this.busOrgList.find(v1 => v1.key === v.busOrgId)) {
          this.busOrgList.push({
            key: v.busOrgId,
            label: v.busOrgName
          })
        }
        if (v.purchaseLeadUserId && v.purchaseLeadUserName && !this.purchaseLeadUserList.find(v1 => v1.key === v.purchaseLeadUserId)) {
          this.purchaseLeadUserList.push({
            key: v.purchaseLeadUserId,
            label: v.purchaseLeadUserName
          })
        }
        v.isPlanText = v.isPlan ? '关联' : '未关联'
      })
      this.statusList = Object.keys(statusList).map(v => {
        return { label: statusList[v], key: v }
      })
      this.loading = false
    }
  }
}
</script>

<style scoped lang="less">
.page {
  display: flex;
  flex-direction: column;
  flex: 1;
  background: #EEF3FA;
  padding: 0 16px 12px;
  height: 100%;
  .b-detail-t-s {
    display: flex;
    height: 100%;
    margin-left: 20px;
    align-items: flex-end;
  }
  .count {
    height: 118px;
    display: flex;
    padding: 26px 0;
    background: #fff;
    border-radius: 6px;
    margin-top: 14px;
    justify-content: center;
  }
  .c-item {
    width: 33%;
    padding-left: 64px;
    border-right: 1px solid #D8D8D8;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    .t {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
    }
  }
  .c-item-nb {
    border-right: 0px solid #D8D8D8;
  }
  .num {
    position: relative;
    .img-d {
      width: 61px;
      height: 16px;
      position: absolute;
      right: 23%;
      top: 0;
      img {
        width: 100%;
        height: 100%;
      }

    }
  }
  .detail {
    margin-top: 14px;
    flex: 1;
    background: #FFFFFF;
    border-radius: 6px;
    .search {
      margin: 20px;
      display: flex;
      justify-content: space-between;
      .search-item {
        display: flex;
        flex-direction: column;     
        align-items: center;   
        .label {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }
      }
    }
    .table {
      height: calc(100% - 92px);
      padding: 0 20px 20px;
      width: 100%;
    }
  }
}
</style>

<style lang="less">
.page {
  .b-detail-t-s {
    input {
      background: rgba(0,0,0,0) !important;
    }
  }
}
</style>